import { Accessor } from "IZOX/STATIC";
import { HStack, XButton } from "IZOX/_X";
import { SysTheme } from "__SYSDefault/Theme";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { FaCheck, FaCircle } from "react-icons/fa";

/**
 * @typedef {import("IZOX/_X/XButton").xbuttonparams} xbuttonparams
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * 
 * @typedef {Object} qfcheckboxparamsAddOns
 * @property {String} name
 * @property {lang} label
 * @property {any} defaultValue
 * @property {Function} _onChange
 * @property {Function} _onSetDefault
 * @property {any} formValue
 * @property {String} color
 * @property {String} bColor
 * @property {Number} size
 * @property {"square" | "circle"} checkStyle
 * @property {Boolean} readOnly
 * @property {JSX.Element} inject
 * @property {({doc, field, addOns}) => Boolean} isError
 * @property {fvalidate | fvalidate[]} validators
 * 
 * @typedef {qfcheckboxparamsAddOns & xbuttonparams} qfcheckparams
 * @param {qfcheckparams} param0
 * @returns 
 */
function QFCheckBox({
  name = undefined,
  label = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  color = SysTheme.BGColors.Primary,
  bColor = SysTheme.Colors.Primary,
  bgColor = SysTheme.BGColors.Primary,
  size = 18,
  style = undefined,
  checkStyle = "square",
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  readOnly,
  inject,
  ...others
}){

  let {disabled} = others;
  const [hover, setHover] = useState(false);

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue ?? false);
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const [value, setValue] = useState(defaultValue);

  const getRound = useCallback(() => {
    switch(checkStyle){
      default: case "square": return 3;
      case "circle": return 50;
    }
  }, [checkStyle]);

  const renderCheck = () => {
    if((!hover && !value) || ((readOnly || disabled) && !value)) return;
    switch(checkStyle){
      default: case "square": return <FaCheck color={bColor} opacity={value ? 1 : 0.5}/>;
      case "circle": return <FaCircle color={bColor} style={{padding: 1}} opacity={value ? 1 : 0.5}/>;
    }
  };

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    setValue(_value);
  }, [formValue, name]);

  if(_.isUndefined(name)) return null;

  return (
    <XButton padding={0} disabled={readOnly} {...others}
      onHover={() => setHover(true)}
      onHoverOff={() => setHover(false)}
      onPress={() => {
        if(readOnly) return;
        _onChange(name, !value);
      }} 
      hoverMode="none"
      round={getRound()}
      notInjectColor style={style}>
      <HStack>
        <HStack flexShrink={0} 
          round={getRound()}
          bW={2}
          bColor={bColor}
          bgColor={value === true ? color: bgColor}
          width={size} height={size}>
          {renderCheck()}
        </HStack>
        {inject}
      </HStack>
    </XButton>
    
  );

}

export default QFCheckBox;